module.exports = __webpack_public_path__ + "img/about-zainiac-banner-1600X1000.0d5c10cf.png";